$(function(){
    
    var _animIndex={},_animStorage={},_imageStorage={};
    $.fn.startOrgyAnim=function(options,timeHandler){
        
        var th=$(this);
        var settings=th.data("myOrgyAnim");
        var animIndex;
        
        var methods={
            addAnimClipCustom:function(img_arr,opt){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                $("<div/>").one("myload",function(){
                    var i;
                    for(i in img_arr){
                        _imageStorage[animIndex][i]=new Image();
                        _imageStorage[animIndex][i].src=img_arr[i];
                    }
                    _animStorage[animIndex].obj_set[obj_index]=new objDrawClipCustom(i,opt);
                }).myLoad(img_arr);
                return animIndex;
            },
            addAnimImages:function(img_arr){
                $("<div/>").one("myload",function(){
                    var i;
                    for(i in img_arr){
                        _imageStorage[animIndex][i]=new Image();
                        _imageStorage[animIndex][i].src=img_arr[i];
                    }
                }).myLoad(img_arr);
            }
            
            
        };
        
        
        
        
        
        
        function objDrawClipCustom(img_name,opt){
            this.imgName=img_name;
            var set=$.extend({
                step_max:-1,
                step_fade_in:-1,
            },opt);
//            anim:{clips:13,width:500,height:542,left:95,top:263}
            this.step=0;
            this.step_max=set.step_max;
            this.clip_period=set.clips;
            var start_point=[],end_point=[];
            if(typeof set.start_point!="undefined"){
                start_point=copyArray(set.start_point);
            }
            if(typeof set.end_point!="undefined"){
                end_point=copyArray(set.end_point);
            }
            if(typeof set.left!="undefined"){
                start_point=[set.left,set.top];
            }
            if(end_point.length==0){
                end_point=copyArray(start_point);
                this.dir=[0,0];
            }
            else{
                this.dir=makeVector(start_point,end_point);
            }
            this.start_point=copyArray(start_point);
            this.end_point=copyArray(end_point);
            this.step_fade_in=set.step_fade_in;
            
            this.imgSize=[set.width,set.height];
        }
        objDrawClipCustom.prototype={
            next:function(ctx,img){
                this.step+=1;
                var x,y;
                if(this.dir[0]==0 && this.dir[1]==0){
                    x=this.start_point[0];
                    y=this.start_point[1];
                }
                else{
                    var div=this.step/this.step_max;
                    x=this.dir[0]*div+this.start_point[0];
                    y=this.dir[1]*div+this.start_point[1];
                }
                var clip=this.step%this.clip_period;
                
                x=Math.round(x);
                y=Math.round(y);
                
                ctx.save(); 
                if(this.step_fade_in!=-1){
                    ctx.globalAlpha = Math.min(1,this.step/this.step_fade_in);
                }
                ctx.drawImage(img,clip*this.imgSize[0],0,this.imgSize[0],this.imgSize[1],x,y,this.imgSize[0],this.imgSize[1]);
                ctx.restore(); 
                
               
                if(this.step_max>0){
                    if(this.step>=this.step_max){
                        return 0;
                    }
                }
                
                return 1;
            }
        };
        
        if(!settings){
            if(typeof options!="object"){
                return false;
            }
            settings=$.extend( {
                period:40,
            }, options);
            
            function getNewAnimIndex(){
                var i=getNewObjectIndex(_animIndex,{});
                _animIndex[i]={period:timeHandler.getNewIndex()};
                _animStorage[i]={"obj_set":{}};
                return i;
            }
            if(typeof timeHandler=="undefined" || typeof timeHandler.getNewIndex=="undefined"){
                return false;//was not init
            }
            animIndex=getNewAnimIndex();
            _imageStorage[animIndex]={};
            var animIndexArr=_animIndex[animIndex];
            settings.animIndex=animIndex;
            settings.width=intval(th.attr("width"));
            settings.height=intval(th.attr("height"));
            var ctx=th[0];
            ctx=ctx.getContext("2d");
            
            
            function drawScene(){
                ctx.clearRect(0, 0, settings.width, settings.height);
                if(typeof _animStorage[animIndex]!=="undefined"){
                    var i,is_ava,obj;
                    
                    
                    
                    for(i in _animStorage[animIndex].obj_set){
                        obj=_animStorage[animIndex].obj_set[i];
                        if(typeof obj.next=="undefined"){

                        }
                        else{
                            if(typeof obj.imgName!="undefined"){
                                if(typeof _imageStorage[animIndex][obj.imgName]!="undefined"){
                                    is_ava=obj.next(ctx,_imageStorage[animIndex][obj.imgName]);
                                }
                                else{
                                    is_ava=0;
                                }
                            }
                            else{
                                is_ava=obj.next(ctx);
                            }
                        }

                        if(!is_ava){
                            delete _animStorage[animIndex].obj_set[i];
                        }
                    }
                }
                return true;
            }
            
            
            timeHandler.set(animIndexArr.period,function(){
                drawScene();
            },settings.period,function(){
                delete _animIndex[animIndex];
                delete _animStorage[animIndex];
            });
            th.data("myOrgyAnim",settings);
            
            
            
            
        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            animIndex=settings.animIndex;
            if(methods[options]){
                return methods[options].apply(this,arg);
            }
        }
        
        return true;
        
    };
});

